import _groupBy from 'lodash/groupBy';

export default (panels) => _groupBy(panels, 'groupId');
